// Single source of truth for Karl Kramer author identity (visible content).
// Structured-data Person entity lives in components/site/Seo.jsx (PERSON_ID / personSchema).
export const AUTHOR = {
  name: "Karl Kramer",
  jobTitle: "CEO",
  titleLine: "CEO of Best Buy Incentives",
  path: "/authors/karl-kramer",
  image: "/images/authors/karl-kramer.png",
  imageAlt: "Karl Kramer, CEO of Best Buy Incentives",
  linkedin: "https://www.linkedin.com/in/karl-kramer-34803516a/",
  bioShort:
    "Karl Kramer is CEO of Best Buy Incentives and has spent more than three decades helping salespeople and sales organizations improve closing rates through travel incentives. He helps high-ticket sales teams use discounted travel vouchers to create urgency, strengthen perceived value, differentiate offers, and protect margin.",
  bioLong:
    "Karl Kramer is the CEO of Best Buy Incentives. For more than three decades, he has helped salespeople and sales organizations improve closing rates through travel incentives. Karl specializes in helping high-ticket sales teams use discounted travel vouchers to create urgency, strengthen perceived value, differentiate an offer, and protect margin without relying on deeper price cuts. His practical experience spans customer incentive strategy, campaign structure, salesperson adoption, objection resolution, and the use of memorable incentives to help qualified buyers move forward.",
  expertise: [
    "Sales closing incentives",
    "Discounted travel vouchers",
    "High-ticket sales strategy",
    "Customer incentive programs",
    "Sales promotions and offer differentiation",
    "Margin protection",
    "Sales-team adoption and campaign execution",
  ],
};
